<template>
  <ControlWrapper
    v-bind="control.controlWrapper.value"
    :styles="control.styles"
    :is-focused="control.isFocused.value"
    :applied-options="control.appliedOptions.value"
    :class="control.styles.control.accordion"
  >
    <WAccordion
      :title="accordionConfig.title"
      :bullets="accordionConfig.bullets"
      :icon="accordionConfig.icon"
      :up-icon="accordionConfig.upIcon"
      :down-icon="accordionConfig.downIcon"
    ></WAccordion>
  </ControlWrapper>
</template>

<script setup lang="ts">
  import { ControlElement } from '@jsonforms/core';
  import { rendererProps, useJsonFormsControl } from '@jsonforms/vue';
  import { default as ControlWrapper } from './ControlWrapper.vue';
  import { useWidgetControl } from '../util';
  import WAccordion from '../../base/Accordion.vue';

  export type AccordionConfig = {
    title: string;
    bullets: string[];
    icon: string;
    downIcon: string;
    upIcon: string;
  };

  const props = defineProps(rendererProps<ControlElement>());
  const control = useWidgetControl(useJsonFormsControl(props));
  const accordionConfig = (control.control.value.schema as unknown as { accordion: AccordionConfig }).accordion;
</script>
